import React from 'react';
import { useMenu } from 'hooks';
import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

const LessonItem = ({
	lesson,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(lesson, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(lesson, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(lesson.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(lesson)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected}
						onChange={() => handleSelect(lesson)}
						name="lesson"
						color="primary"
					/>
				</TableCell>
			)}

			<TableCell>
				<Typography variant="primart.text">{lesson.title}</Typography>
			</TableCell>

			<TableCell>
				<Typography variant="primart.text">{lesson.level}</Typography>
			</TableCell>

			<TableCell>
				<Typography variant="primart.text">{lesson.trainer?.name}</Typography>
			</TableCell>

			<TableCell>
				<Typography variant="primart.text">{lesson.category_name}</Typography>
			</TableCell>

			<TableCell>
				<Typography
					variant="primart.text"
					color={lesson.published ? 'success.main' : 'text.secondary'}
				>
					{lesson.published ? 'Yes' : 'No'}
				</Typography>
			</TableCell>

			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default LessonItem;
